import { useWSMutation, WSMutationsConfig } from "@ws-react-query";
import { WSServiceError } from "../../utils/serviceHelper";
import { enrollInMeridio } from "../../services/api/benefits/meridioPlanEnrollment/enrollInMeridio";
import {
  IEnrollInMeridioRequest,
  IEnrollInMeridioResponse
} from "../../services/api/benefits/meridioPlanEnrollment/types";
import { QUERY_ACTIVE_MERIDIO_PLAN_ENROLLMENTS } from "./useQueryActiveMeridioPlanEnrollments";

export const useMutationEnrollInMeridio = (
  config?: WSMutationsConfig<
    IEnrollInMeridioResponse,
    WSServiceError,
    IEnrollInMeridioRequest
  >
) =>
  useWSMutation<
    IEnrollInMeridioResponse,
    WSServiceError,
    IEnrollInMeridioRequest
  >(enrollInMeridio, {
    dependencies: [QUERY_ACTIVE_MERIDIO_PLAN_ENROLLMENTS],
    ...config
  });
